import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";

export class NewsletterTheBackchannelWidget extends Widget {
	componentWillMount() {
		this.handleCheckbox = this.handleCheckbox.bind(this);
		this.getData();
	}

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const addToMultipleLists = urlParams.get("addToMultipleLists");
		if (addToMultipleLists) {
			this.postData({ addToMultipleLists });
		}
	}

	clearErrors() {
		this.setState({ errors: null });
	}

	getData() {
		this.request("GET");
	}

	postData(opts) {
		this.clearErrors();
		this.request("POST", opts);
	}

	request(method, data = {}) {
		const self = this;

		let params = `?`;
		Object.keys(data).forEach((k) => {
			params += `${k}=${data[k]}&`;
		});

		fetch(
			`https://accounts.${document.location.hostname}/doesspress/email-list${params}`,
			{
				method: `${method}`,
				credentials: "include",
			}
		)
			.then((r) => {
				return r.json();
			})
			.then((r) => {
				if (method === "GET") {
					console.log(r.bindings);
					self.setState({
						emailLists: r.bindings.emailLists,
						ident: r.bindings.ident,
					});
				} else {
					if (r.errors) {
						self.setState({ error: r.errors[0] });
					}
					if (r.confirmation) {
						self.setState({ confirmation: r.confirmation });
					}
				}
			});
	}

	handleCheckbox(e) {
		const signedIn = this.state.ident.id;
		if (!signedIn) return;

		const opts = {
			listId: e.target.parentElement.querySelector('input[name="listId"]')
				.value,
		};
		//only set this if checkbox is checked, send nothing otherwise
		if (e.target.checked) opts.addToList = true;

		debugger;

		this.postData(opts);
	}

	renderForm(list) {
		return (
			<div>
				<input
					className="NewslettersLanding__Checkbox"
					id={`id_${list.id}`}
					name="addToList"
					type="checkbox"
					defaultChecked={list.subscribed}
					style={{ display: "none" }}
					onChange={this.handleCheckbox}
				/>
				<label for={`id_${list.id}`}>
					<div class="Button --charcoal-empty" key={Math.random()}>
						<input type="hidden" name="listId" value={list.id} />
						{list.subscribed ? (
							<span class="checked">
								<Icon name="circle-check" style="light" /> Subscribed
							</span>
						) : (
							<span class="unchecked">
								<Icon name="plus" style="light" />
								Subscribe
							</span>
						)}
					</div>
				</label>
			</div>
		);
	}

	renderContent() {
		if (this.state.error && !this.state.emailLists)
			return <div>Something went wrong</div>;
		if (!this.state.emailLists) return <div>Loading...</div>;

		const lists = this.state.emailLists;

		const backchannel = lists.find((list) => list.slug === "the_backchannel");

		return (
			<div>
				{this.state.error && (
					<p
						style={{
							fontWeight: "bold",
							background: "#f5cad0",
							color: "#ff0000",
							padding: "16px",
							borderRadius: "6px",
						}}
					>
						{this.state.error.message}
					</p>
				)}
				{this.renderForm(backchannel)}
			</div>
		);
	}
}
